import { fetchTrainList } from '@/service/trainConfirm'
let trainListLock = false
const state = {
  feedback: null,
  trainList: [],
}
const mutations = {
  setFeedback(state, feedback) {
    state.feedback = feedback
  },
  setTrainList(state, list) {
    state.trainList = list
  },
}
const actions = {
  async getTrainList({ state, commit }, { srId }) {
    const { trainList } = state
    if (!trainList.length && !trainListLock) {
      trainListLock = true
      commit('setTrainList', await fetchTrainList(srId))
      trainListLock = false
    }
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
